import { IRootState } from '../../../../../store'

export const getBodyViewSelector = (state: IRootState) => state.burns.bodyView
